<div class="uk-section">
  <div class="uk-container">
    <h1 class="uk-heading-line uk-animation-slide-right-small">
      <span>Education</span>
    </h1>
    <app-shared-card-grid [cards]=getCards() [columns]="2"></app-shared-card-grid>
  </div>
  <div class="uk-container uk-margin-medium-top">
    <ul uk-accordion>
      <li class="uk-open">
        <a class="uk-accordion-title" href="#">Publications</a>
        <div class="uk-accordion-content">
          <ul class="uk-list uk-list-striped uk-list-divider">
            <li>
              <a href="https://doi.org/10.1145/3786304.3787924">2026 CHIIR - PulseSearch: Modeling Long- and Short-term Patterns for Personalized Music Search Suggestions</a>
            </li>
            <li>
              <a href="https://link.springer.com/chapter/10.1007/978-3-319-98932-7_5">2018 CLEF - Learning-to-Rank and Relevance Feedback for Literature Appraisal in Empirical Medicine</a>
            </li>
            <li>
              <a href="https://www.ijcai.org/proceedings/2018/0841.pdf">2018 IJCAI - Hatebusters: A Web Application for Actively Reporting YouTube Hate Speech</a>
            </li>
            <li>
              <a href="https://dl.acm.org/doi/10.1145/3035918.3058732">2017 SIGMOD - Alpine: Efficient In-Situ Data Exploration in the Presence of Updates</a>
            </li>
            <li>
              <a href="https://intelligence.csd.auth.gr/publications/anagnostou-clef-2017.pdf">2017 CLEF - Combining Inter-Review Learning-to-Rank and Intra-Review Incremental Training for Title and Abstract Screening in Systematic Reviews</a>
            </li>
          </ul>
        </div>
      </li>
    </ul>
</div>
</div>
